import axios from '@axios'

export const state = {
  cities: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecord: 0,
}

export const getters = {
  allCities: (state) => state.cities,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_CITYS: (state, resp) => {
    if (!resp) return null
    state.cities = resp.cities
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  CREATE_CITY: (state, city) => {
    state.cities.unshift(city)
  },
  UPDATE_CITY: (state, city) => {
    let clone = []
    for (let i = 0; i < state.cities.length; i++) {
      if (state.cities[i].id === city.id) {
        clone[i] = city
      } else {
        clone[i] = state.cities[i]
      }
    }
    state.cities = clone
  },
  DELETE_CITY: (state, city) => {
    state.cities = state.cities.filter((s) => s.id !== city.id)
  },
}

export const actions = {
  // async getCities({ commit }, params) {
  //   await axios
  //     .get(`/api/cities`, { params: params })
  //     .then((resp) => {
  //       if (resp.status === 200) {

  //         commit('GET_CITYS', resp.data)
  //       }
  //     })
  //     .catch((err) => {
  //       commit(
  //         'GET_CITYS',
  //         err.response.status === 404 ? { cities: [] } : null
  //       )
  //     })
  // },

  async getCities({ commit }, params = {}) {
    await axios
      .get('/api/cities', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_CITYS', resp.data)
        }
      })
      .catch((err) => {
        commit('GET_CITYS', err.response.status === 404 ? { cities: [] } : null)
      })
  },
  async createCity({ commit }, city) {
    return axios.post('/api/city', city)
  },
  async updateCity({ commit }, city) {
    return axios.put('/api/city', city)
  },

  async deleteCity({ commit, dispatch }, city) {
    await axios.delete('/api/city', { data: city }).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_CITY', city)
        let notification = {
          id: Date.now(),
          type: 'success',
          title: 'DELETE',
          message: 'The city has been deleted',
        }
        dispatch('notification/addNotification', notification, { root: true })
      }
    })
  },
}
